export default "__VITE_ASSET__DEsnA$tH__";